import { makeStyles } from '@material-ui/styles'

export default makeStyles(_ => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  btnPlanContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
  govBrContainer: {
    maxWidth: '50vw',
  },
}))
